<template>
    <div class="margin__top__20">
        <NewPetOwnerForm ref="NewPetOwnerForm" />
        <div class="row margin__top__20 margin__bottom__50">
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__secondary" @click="goBack()">Previous</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__primary pull-right" @click="MoveToNextPage">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewPetOwnerForm from '../components/NewPetOwnerForm'
export default {
    name: "PetOwnerDetails",
    components: { NewPetOwnerForm },
    computed: {
        ...mapGetters({
            selectedPractice: 'selectedPractice',
            newPetForm: 'newPetForm',
            selectedPet: 'selectedPet'
        })
    },
    created() {
        if (!this.selectedPractice) {
            this.$router.push({ name: 'Practices' })
        }
        this.$store.dispatch('SetPageNumber', 2);
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'Practices' })
        },
        MoveToNextPage() {
            if (this.newPetForm != null && this.newPetForm.Name != '') {
                this.$router.replace({ name: 'NewPet' })
            }
            else if (this.selectedPet != null && this.selectedPet.PetId > 0) {
                this.$router.replace({ name: 'PetList' })
            }
            else {
                var isValidForm = this.$refs.NewPetOwnerForm.ValidateAll();
                if (isValidForm) {
                    this.$store.dispatch('FindMatchingPets')
                        .then(response => {
                            if (response && response.length > 0) {
                                if (window.console) {
                                    console.log('Old petowner found InitializePets');
                                }
                                this.$store.dispatch('InitializePets', response);
                                this.$router.replace({ name: 'PetList' })
                            }
                            else {
                                this.$router.replace({ name: 'NewPet' })
                            }
                        },
                        error => {
                             this.$router.replace({ name: 'NewPet' })
                        });
                }
                else {
                }
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/PetOwnerDetails.vue